import { Routes } from '@angular/router';

import { AuthGuard } from '@lib/auth';

import { InsurancePackageResolver } from '@admin/src/resolvers/insurance-package.resolver';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/access/guest/guest.component').then(c => c.GuestComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./pages/access/authorized/authorized.component').then(c => c.AuthorizedComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'clients',
      },
      {
        path: 'clients',
        loadComponent: () => import('./pages/clients/clients.component').then(c => c.ClientsComponent),
      },
      {
        path: 'insurance-packages',
        loadComponent: () => import('./pages/insurance-packages/insurance-packages.component').then(c => c.InsurancePackagesComponent),
      },
      {
        path: 'insurance-packages/create',
        loadComponent: () => import('./pages/insurance-packages/insurance-package-edit/insurance-package-edit.component').then(c => c.InsurancePackageEditComponent),
      },
      {
        path: 'insurance-packages/:packageId/edit',
        loadComponent: () => import('./pages/insurance-packages/insurance-package-edit/insurance-package-edit.component').then(c => c.InsurancePackageEditComponent),
        resolve: { insurancePackageData: InsurancePackageResolver },
      },
      {
        path: 'gift-codes/create',
        loadComponent: () => import('./pages/gift-codes/gift-codes.component').then(c => c.GiftCodesComponent),
      },
      {
        path: 'invoices/sending',
        loadComponent: () => import('./pages/sending-invoices/sending-invoices.component').then(c => c.SendingInvoicesComponent),
      },
      {
        path: 'achi-codes',
        loadComponent: () => import('../../../../packages/shared-ui/src/modules/achi-codes/achi-codes.component').then(c => c.AchiCodesComponent),
      },
      {
        path: 'diagnoses',
        loadComponent: () => import('../../../../packages/shared-ui/src/modules/diagnoses/diagnoses.component').then(c => c.DiagnosesComponent),
      },
      {
        path: 'partners',
        loadComponent: () => import('./pages/partners/partners.component').then(c => c.PartnersComponent),
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/partners/partners-overview/partners-overview.component').then(c => c.PartnersOverviewComponent),
          },
          {
            path: 'create',
            loadComponent: () => import('./pages/partners/partner-hub/partner-hub.component').then(c => c.PartnerHubComponent),
            children: [
              {
                path: '',
                loadComponent: () => import('@admin/src/ui/pages/partners/partner-edit/partner-edit.component').then(c => c.PartnerEditComponent),
                pathMatch: 'full',
              },
            ],
          },
          {
            path: ':partnerId',
            loadComponent: () => import('./pages/partners/partner-hub/partner-hub.component').then(c => c.PartnerHubComponent),
            children: [
              {
                path: '',
                loadComponent: () => import('@admin/src/ui/pages/partners/partner-edit/partner-edit.component').then(c => c.PartnerEditComponent),
                pathMatch: 'full',
              },
              {
                path: 'locations',
                loadComponent: () =>
                  import('@admin/src/ui/pages/partners/partner-locations-overview/partner-locations-overview.component').then(c => c.PartnerLocationsOverviewComponent),
              },
              {
                path: 'doctors',
                loadComponent: () =>
                  import('@admin/src/ui/pages/partners/partner-doctors-overview/partner-doctors-overview.component').then(c => c.PartnerDoctorsOverviewComponent),
              },
              {
                path: 'offerings',
                loadComponent: () =>
                  import('@admin/src/ui/pages/partners/partner-offerings-overview/partner-offerings-overview.component').then(c => c.PartnerOfferingsOverviewComponent),
              },
            ],
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
